<div class="toast" (mouseenter)="pauseToast()" (mouseleave)="resumeToast()" [ngClass]="getToastClass()">
    <div class="toast__icon">
        <img [src]="getToastIcon()" alt=icons />
    </div>

    <div class="toast__text">
        <h3 class="toast__title">{{toast.title}}</h3>
        <p class="toast__description">{{toast.message}}</p>
    </div>
</div>